import { useAuth } from 'contexts/AuthContext';
import { NoopT } from 'declarations/types/common';

type UseUserInfoT = {
  handleSignOutClick: NoopT;
};

const useUserInfo = (): UseUserInfoT => {
  /**
   * Hooks
   */
  const { signOut } = useAuth();

  /**
   * Handlers
   */
  const handleSignOutClick = () => {
    signOut();
  };

  return {
    handleSignOutClick,
  };
};

export default useUserInfo;
